import {faBoxTaped, faListTimeline, faMagnifyingGlass} from "@fortawesome/pro-regular-svg-icons";
import {z} from "zod/v4";

export const Facets = [
    "cargo", "timeline", "inspect"
] as const;

export const facetIcons = {
    cargo: faBoxTaped,
    timeline: faListTimeline,
    inspect: faMagnifyingGlass,
} as const;

export const Facet = z.enum(Facets);
export type Facet = z.infer<typeof Facet>;

// import {isString} from "lodash";
//

// export function toggleCargoOrTimeline(from: CargoOrTimeline): CargoOrTimeline {
//     return from === "cargo" ? "timeline" : "cargo";
// }

// export interface CargoTimelineSwitchProps extends SheetProps {
//     value: CargoOrTimeline;
//     icons: Record<CargoOrTimeline, IconDefinition>;
//     orientation?: "horizontal" | "vertical";
// }
//
// const commonSx = {
//     p: 0.8,
//     my: 0.4,
// };
//
// export function CargoTimelineSwitch(
//     {
//         value,
//         color,
//         icons,
//         sx: inSx,
//         ...rest
//     }: CargoTimelineSwitchProps) {
//
//     const sx = {...inSx, ...(color ? {bgcolor: `${color}.softBg`} : {})};
//     const groupProps = {
//         ...rest,
//         ...(color ? {color} : {}),
//     };
//
//     if (value === "cargo") {
//         return <ButtonGroup sx={sx} {...groupProps}>
//             <IconButton size="sm" sx={commonSx} variant="solid" color={color}>
//                 <FontAwesomeIcon icon={icons.cargo} size="2x"/>
//             </IconButton>
//             <IconButton size="sm" sx={commonSx} variant="soft" color={color}>
//                 <FontAwesomeIcon icon={icons.timeline} size="2x"/>
//             </IconButton>
//         </ButtonGroup>
//     } else {
//         return <ButtonGroup sx={sx} {...groupProps}>
//             <IconButton size="sm" sx={commonSx} variant="soft">
//                 <FontAwesomeIcon icon={icons.cargo} size="2x"/>
//             </IconButton>
//             <IconButton size="sm" sx={commonSx} variant="solid">
//                 <FontAwesomeIcon icon={icons.timeline} size="2x"/>
//             </IconButton>
//         </ButtonGroup>
//     }
// }

// export interface CargoTimelineSearchParams {
//     facet?: TruckFacet;
// }
//
